export const getFakeCovers = ({
  scales: {brandForm},
}: {
  scales: {brandForm: Record<any, string>}
}) => ({
  fakeCovers: {
    backgroundColors: Object.values(brandForm),
  },
})
